import styled from 'styled-components'

/** Section label for document/suggestion forms — matches `Input` labels. */
export const FormSectionEyebrow = styled.h4<{ $hasLead?: boolean }>`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  line-height: ${({ theme }) => theme.fontSize.md}rem;
  font-weight: ${({ $hasLead }) => ($hasLead ? 500 : 'bold')};
  color: ${({ theme }) => theme.colors.metalGray};

  strong {
    font-weight: bold;
  }
`
